/**
 * Zentrale Datumsformatierung für GB Sylt Bestellwelt
 * Format: dd.mm.yyyy (deutsches Format)
 * 
 * Speicherung im Backend bleibt unverändert (ISO-Format yyyy-mm-dd)
 * Nur die Darstellung wird formatiert
 */

/**
 * Formatiert ein Datum ins deutsche Format tt.mm.jjjj
 * @param {string|Date} dateInput - Datum als ISO-String (yyyy-mm-dd), ISO-Timestamp oder Date-Objekt
 * @param {boolean} includeTime - Optional: Zeit mit anzeigen (HH:mm)
 * @returns {string} Formatiertes Datum (z.B. "20.03.2026" oder "20.03.2026, 14:30")
 */
export function formatDate(dateInput, includeTime = false) {
  if (!dateInput) return '-';
  
  try {
    let date;
    
    // Handle different input types
    if (dateInput instanceof Date) {
      date = dateInput;
    } else if (typeof dateInput === 'string') {
      // Handle ISO date string (yyyy-mm-dd) or ISO timestamp
      date = new Date(dateInput);
    } else {
      return String(dateInput);
    }
    
    // Check if valid date
    if (isNaN(date.getTime())) {
      return String(dateInput);
    }
    
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    
    let formatted = `${day}.${month}.${year}`;
    
    if (includeTime) {
      const hours = String(date.getHours()).padStart(2, '0');
      const minutes = String(date.getMinutes()).padStart(2, '0');
      formatted += `, ${hours}:${minutes}`;
    }
    
    return formatted;
  } catch (e) {
    console.error('Date formatting error:', e);
    return String(dateInput);
  }
}

/**
 * Formatiert ein Datum mit Uhrzeit (tt.mm.jjjj, HH:mm)
 * @param {string|Date} dateInput - Datum als ISO-String oder Date-Objekt
 * @returns {string} Formatiertes Datum mit Zeit (z.B. "20.03.2026, 14:30")
 */
export function formatDateTime(dateInput) {
  return formatDate(dateInput, true);
}

/**
 * Konvertiert deutsches Datum (tt.mm.jjjj) zurück zu ISO-Format (yyyy-mm-dd)
 * Nützlich für API-Aufrufe
 * @param {string} germanDate - Datum im Format tt.mm.jjjj
 * @returns {string} Datum im ISO-Format yyyy-mm-dd
 */
export function parseGermanDate(germanDate) {
  if (!germanDate) return '';
  
  const parts = germanDate.split('.');
  if (parts.length !== 3) return germanDate;
  
  const [day, month, year] = parts;
  return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
}

export default { formatDate, formatDateTime, parseGermanDate };
